module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    attrs: {
      "id": "profile-pic-container"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/',
      "exact": ""
    }
  }, [_c('img', {
    attrs: {
      "id": "profile-pic",
      "src": require("../assets/profile.jpg")
    }
  })])], 1), _vm._v(" "), _c('ul', [_vm._l((_vm.pages.first), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": link.to,
        "exact": ""
      }
    }, [_vm._v(_vm._s(link.name))])], 1)
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.pages.second), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": link.to,
        "exact": ""
      }
    }, [_vm._v(_vm._s(link.name))])], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09b47e4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 68
// module chunks = 0